<p>design-template-stats works!</p>
